import React from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import BaseCard from '../common/layout/BaseCard';
// import { Button } from '../common/ui/Button';

const CommunityAnnouncementCard: React.FC = () => {
  return (
    <BaseCard className="group h-full overflow-hidden bg-primary-400 relative flex flex-col">
      <div className="p-4 sm:p-6 md:p-6 flex flex-col justify-between flex-grow relative z-10">
        <div className="flex-grow">
          {/* Community Update Header */}
          <div className="flex items-center mb-4">
            <UserGroupIcon className="h-5 w-5 text-blue-100 mr-2" />
            <span className="text-blue-100 font-medium">Community Update</span>
          </div>

          {/* Title */}
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:max-w-[90%] md:max-w-[85%]">
            Coming soon: Create your own community and connect with like-minded professionals
          </h3>
        </div>

        {/* Add Community Button */}
        {/* <div className="mt-8 pb-3">
          <Button
            variant="filled"
            color="white"
            size="small"
            className="w-fit font-medium text-sm text-primary-700"
            disabled={true}
          >
            Create (coming soon)
          </Button>
        </div> */}
      </div>

      {/* Circle SVG */}
      <svg
        width="180"
        height="260"
        viewBox="0 0 76 110"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute bottom-0 right-0 transform translate-x-12 translate-y-12"
      >
        <g clipPath="url(#clip0_6939_26128)">
          <path
            d="M71.0429 0.277344C31.8028 0.277344 0.000725172 32.0794 0.00072564 71.3195C0.000726108 110.56 31.8028 142.362 71.0429 142.362C72.9246 142.362 74.7866 142.263 76.6387 142.124L76.6387 103.815C74.8163 104.122 72.9543 104.3 71.0429 104.3C52.8292 104.3 38.0721 89.5331 38.0721 71.3294C38.0721 53.1256 52.8292 38.3388 71.0429 38.3388C72.9543 38.3388 74.8163 38.5072 76.6387 38.8241L76.6387 0.515042C74.7866 0.366481 72.9246 0.277344 71.0429 0.277344Z"
            fill="#60A5FA"
          />
          <path
            d="M38.0721 71.3166C38.0721 89.5302 52.8391 104.287 71.0429 104.287C72.9543 104.287 74.8163 104.119 76.6387 103.802L76.6387 38.8212C74.8163 38.5142 72.9543 38.3359 71.0429 38.3359C52.8292 38.3359 38.0721 53.103 38.0721 71.3067L38.0721 71.3166Z"
            fill="#93C5FD"
          />
        </g>
        <defs>
          <clipPath id="clip0_6939_26128">
            <rect width="110" height="76" fill="white" transform="translate(76) rotate(90)" />
          </clipPath>
        </defs>
      </svg>
    </BaseCard>
  );
};

export default CommunityAnnouncementCard; 